import {
  DECK_COMPLETION_ERROR_CODE,
  DECK_WRITE_ERROR_CODE,
} from '@lib/types/deck';

import AppError from '../app-error';

export const getRateLimitMessage = (error: unknown): string | undefined =>
  error instanceof AppError && error.isRateLimited
    ? AppError.rateLimitMessage(error.retryAfterMs)
    : undefined;

export const getErrorMessage = (error: unknown, fallback: string): string => {
  const rateLimitMessage = getRateLimitMessage(error);

  if (rateLimitMessage) {
    return rateLimitMessage;
  }

  if (error instanceof AppError) {
    if (error.isServiceUnavailable) {
      return 'Nossos serviços estão temporariamente indisponíveis. Por favor, tente novamente mais tarde.';
    }

    if (error.isUnauthorized) {
      return 'Sua sessão expirou. Por favor, faça login novamente.';
    }

    if (error.code === 'legal-acceptance-required') {
      return 'Confirme os Termos de Uso atualizados para iniciar uma nova operação comercial.';
    }

    if (error.code === 'seller-legal-acceptance-required') {
      return 'Esta loja está temporariamente indisponível para novas compras.';
    }

    if (error.isForbidden) {
      return 'Você não tem permissão para realizar esta ação.';
    }

    const messages: Record<string, string> = {
      [DECK_WRITE_ERROR_CODE.VERSION_CONFLICT]:
        'Este deck foi atualizado em outra sessão. Recarregue e revise suas alterações antes de salvar.',
      [DECK_COMPLETION_ERROR_CODE.EMPTY]:
        'Adicione e salve pelo menos uma carta antes de concluir o deck.',
      [DECK_COMPLETION_ERROR_CODE.UNRESOLVED]:
        'Há cartas importadas sem correspondência no catálogo. Na lista do deck, revise as cartas importadas pendentes e vincule cada linha à carta correta antes de concluir.',
      [DECK_COMPLETION_ERROR_CODE.NOT_OWNED]:
        'Informe todas as cópias em coleção antes de concluir este deck de coleção.',
      [DECK_COMPLETION_ERROR_CODE.INVALID_SECTIONS]:
        'Para concluir um deck Advanced de Yu-Gi-Oh!, use 40–60 cartas no Main, até 15 no Extra e até 15 no Side.',

      'cpf-in-use': 'O CPF informado já está em uso.',
      'cart-offer-limit-reached':
        'A quantidade solicitada excede o limite desta oferta.',
      'cart-store-purchase-limit-reached':
        'O limite de compra desta loja foi atingido.',
    };

    return messages[error.code] ?? fallback;
  }

  return fallback;
};

export const isDeckVersionConflict = (error: unknown) =>
  error instanceof AppError &&
  error.code === DECK_WRITE_ERROR_CODE.VERSION_CONFLICT;
